const STORAGE_KEY = 'dt-audience-filter-category-names'

export function readStoredCategoryTokenNames(): Record<string, string> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return {}
    }
    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object') {
      return {}
    }
    return parsed as Record<string, string>
  } catch {
    return {}
  }
}

export function mergeStoredCategoryTokenNames(
  names: Record<string, string>,
): Record<string, string> {
  const merged = { ...readStoredCategoryTokenNames(), ...names }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
  } catch {
    // sessionStorage may be unavailable; in-memory merge still applies this call.
  }
  return merged
}

export function clearStoredCategoryTokenNames(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Ignore storage failures.
  }
}

export function pruneStoredCategoryTokenNames(
  activeTokens: Array<string>,
): Record<string, string> {
  const active = new Set(activeTokens)
  const stored = readStoredCategoryTokenNames()
  const pruned: Record<string, string> = {}
  for (const [token, name] of Object.entries(stored)) {
    if (active.has(token)) {
      pruned[token] = name
    }
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pruned))
  } catch {
    // Ignore storage failures.
  }
  return pruned
}
